/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import * as Yup from 'yup';

import { SUJiraConfigGetResponse } from '../../types/superuser/config/SUJiraConfigGetResponse';

export const generateInitialValues = (config?: SUJiraConfigGetResponse) => ({
  atlassianUrl: config?.configData.atlassianUrl ?? '',
  email: config?.configData.email ?? '',
  serviceDeskKey: config?.configData.serviceDeskKey ?? '',
  token: config?.configData.token ?? '',
});

export const supportConfigValidationSchema = Yup.object({
  atlassianUrl: Yup.string().trim().required('empty'),

  email: Yup.string().trim().email().required('empty'),

  serviceDeskKey: Yup.string().trim().required('empty'),

  token: Yup.string().trim().required('empty'),
});
